import React from "react";
import { Container, Button, Card, Form } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import AddIcon from "../Assets/Icons/addIcon.svg";
import "../Styles/Admin.css";
import TextEditor from "../Components/TextEditor";
import PublishIcon from "../Assets/Icons/publishIcon.svg";
import SettingIcon from "../Assets/Icons/setting.svg";
import HomeIcon from "../Assets/Icons/homeIcon.svg";
import DropDownIcon from "../Assets/Icons/dropDownIcon.svg";
import UnCheckedIcon from "../Assets/Icons/unCheckedIcon.svg";
import CheckIcon from "../Assets/Icons/checkMarkIcon.svg";

export default function AdminCreateBlog() {
  return (
    <Container fluid>
      <PageLayout>
        <div>
          <div className="create-blog-btns">
            <Button className="create-blog-btn" variant="outline-primary">
              <img style={{width: '1.5rem', height: '1.5rem'}} src={AddIcon} />
              Add New Post
            </Button>
            <Button
              style={{
                color: "#008BD9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.80rem",
                boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.32)",
              }}
              variant="light"
            >
              <img style={{width: '1.25rem', height: '1.25rem'}} src={PublishIcon} />
              Publish
            </Button>
          </div>
          <div className="create-post-setting-con">
            <TextEditor />
            <Card className="post-setting-card">
              <div className="post-setting-card-header">
                <img src={SettingIcon} />
                <p>Post Setting</p>
              </div>
              <div className="post-setting-card-body">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "1rem 1.5rem 1rem 1.5rem",
                  }}
                >
                  <div className="post-setting-body-dropdown">
                    <img src={HomeIcon} />
                    <p>Categories & Tags</p>
                  </div>
                  <img
                    style={{ width: "1rem", height: "1rem" }}
                    src={DropDownIcon}
                  />
                </div>
                <div className="post-setting-divider"></div>
                <div className="post-setting-body-sec-two">
                  <p className="sec-two-heading">Categories</p>
                  <div className="post-body-sec-two-list-con">
                    <div className="post-body-sec-two-list">
                      <img src={UnCheckedIcon} />
                      <p>Branding</p>
                    </div>
                    <div className="post-body-sec-two-list">
                      <img src={CheckIcon} />
                      <p>Development</p>
                    </div>
                    <div className="post-body-sec-two-list">
                      <img src={UnCheckedIcon} />
                      <p>Industraial</p>
                    </div>
                    <div className="post-body-sec-two-list">
                      <img src={AddIcon} />
                      <p style={{ color: "#47494A" }}>Add New Categories</p>
                    </div>
                    <div>
                      <Form.Group controlId="formBasic">
                        <Form.Label id='label-create-blog' style={{ color: "#27293D" }}>
                        Tags
                        </Form.Label>
                        <Form.Control
                          className="shadow-none"
                          style={{ border: "1px solid #B3B3B3" }}
                          type="text"
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
